import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SwiperComponent } from './components/swiper/swiper.component';
import { McRAIIconModule } from '../icon/icon.module';
import { McRAIButtonModule } from '../button/button.module';
import { SlideDirective } from './directives/slide.directive';

@NgModule({
  imports: [
    CommonModule,
    McRAIIconModule,
    McRAIButtonModule
  ],
  declarations: [
    SwiperComponent,
    SlideDirective
  ],
  exports: [
    SwiperComponent,
    SlideDirective
  ]
})
export class McRAISwiperModule { }
